import { render, staticRenderFns } from "./MdPatientRegistrationInfo.vue?vue&type=template&id=60f66ecc&"
import script from "./MdPatientRegistrationInfo.vue?vue&type=script&lang=js&"
export * from "./MdPatientRegistrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports